import { render, staticRenderFns } from "./ActivationDeliverableContentApprovalHistoryDrawer.vue?vue&type=template&id=042fa451&scoped=true&"
import script from "./ActivationDeliverableContentApprovalHistoryDrawer.vue?vue&type=script&lang=js&"
export * from "./ActivationDeliverableContentApprovalHistoryDrawer.vue?vue&type=script&lang=js&"
import style0 from "./ActivationDeliverableContentApprovalHistoryDrawer.vue?vue&type=style&index=0&id=042fa451&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "042fa451",
  null
  
)

export default component.exports